import { useSelectedSource } from '../components/source-selector/source-selector';
import { camelToSnake } from '../utils/string';
import { useAuthContext } from './useAuthContext';

export function useSources() {
  const { currentAccount } = useAuthContext();
  const { selectedSource, setSelectedSource } = useSelectedSource();

  const sites = (currentAccount?.sites ?? []).map(parseEach);
  const gaProperties = (currentAccount?.gaProperties ?? []).map(parseEach);

  return { sites, gaProperties, selectedSource, setSelectedSource };
}

function parseEach(input) {
  return {
    ...input,
    type: input.__typename ? camelToSnake(input.__typename).toUpperCase() : null,
    active: input.active ?? null,
    id: input.id,
    installed: input.installed ?? null,
    lastData: input.lastData ?? null,
    name: input.name,
  };
}
